<template>
  <div class="geography-masthead">
    <transition>
      <div class="bg" :style="`background-image:url(${$options.static.masthead.image}`" v-if="displayBg"></div>
    </transition>
    <div :class="['location', {active: active}]">
      <h2 @click="active = true">
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" width="512px" height="512px" viewBox="0 0 491.582 491.582" style="enable-background:new 0 0 491.582 491.582;" xml:space="preserve"><g><g><path d="M245.791,0C153.799,0,78.957,74.841,78.957,166.833c0,36.967,21.764,93.187,68.493,176.926 c31.887,57.138,63.627,105.4,64.966,107.433l22.941,34.773c2.313,3.507,6.232,5.617,10.434,5.617s8.121-2.11,10.434-5.617 l22.94-34.771c1.326-2.01,32.835-49.855,64.967-107.435c46.729-83.735,68.493-139.955,68.493-176.926 C412.625,74.841,337.783,0,245.791,0z M322.302,331.576c-31.685,56.775-62.696,103.869-64.003,105.848l-12.508,18.959 l-12.504-18.954c-1.314-1.995-32.563-49.511-64.007-105.853c-43.345-77.676-65.323-133.104-65.323-164.743 C103.957,88.626,167.583,25,245.791,25s141.834,63.626,141.834,141.833C387.625,198.476,365.647,253.902,322.302,331.576z" fill="#FFFFFF"/><path d="M245.791,73.291c-51.005,0-92.5,41.496-92.5,92.5s41.495,92.5,92.5,92.5s92.5-41.496,92.5-92.5 S296.796,73.291,245.791,73.291z M245.791,233.291c-37.22,0-67.5-30.28-67.5-67.5s30.28-67.5,67.5-67.5 c37.221,0,67.5,30.28,67.5,67.5S283.012,233.291,245.791,233.291z" fill="#FFFFFF"/></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg>
        Where on earth is this?
      </h2>
      <div class="reveal">{{ $options.static.masthead.text }}</div>
    </div>
  </div>
</template>

<script>

  import _ from 'lodash'

  const mastheads = [
    {
      image: 'brixby.jpg',
      text: `Brixby Bridge, California`
    },
    {
      image: 'chicago.jpg',
      text: `Chicago, Illinois`
    },
    {
      image: 'dolomite.jpg',
      text: `Dolomites, Alps, Italy`
    },
    {
      image: 'montecarlo.jpg',
      text: `Monte Carlo, Monaco`
    },
    {
      image: 'dorset.jpg',
      text: `Durdle Door, Dorset, England`
    },
    {
      image: 'monument.jpg',
      text: `Monument Valley, Arizona`
    },
    {
      image: 'sidney.jpg',
      text: `Sydney, Australia`
    },
    {
      image: 'rome.jpg',
      text: `Colosseum, Rome, Italy`
    },
    {
      image: 'vietnam.jpg',
      text: `Mu Cang Chai, YenBai, Vietnam`
    },
    {
      image: 'rio.jpg',
      text: `Sugarloaf Mountain, Rio de Janeiro, Brazil`
    },
    {
      image: 'machu.jpg',
      text: `Machu Picchu, Peru`
    },
    {
      image: 'japan.jpg',
      text: `Fujiyoshida, Japan`
    },
    {
      image: 'himalayas.jpg',
      text: `Himalaya Mountains, Nepal`
    },
    {
      image: 'dubai.jpg',
      text: `Burj Khalifa, Dubai`
    },
    {
      image: 'halfdome.jpg',
      text: `Half Dome, Yosemite, California`
    },
    {
      image: 'agua.jpg',
      text: `Agua Azul Waterfalls, Chiapas, Mexico`
    },
    {
      image: 'greatwall.jpg',
      text: `Great Wall of China`
    },
    {
      image: 'guellpark.jpg',
      text: `Guell Park, Barcelona, Spain`
    },
    {
      image: 'shanghai.jpg',
      text: `Shanghai, China`
    },
    {
      image: 'danakil.jpg',
      text: `Danakil Desert, Ethiopia`
    },
    {
      image: 'giantscausway.jpg',
      text: `Giant's Causeway, Northern Ireland`
    },
    {
      image: 'pyramids.jpg',
      text: `The Great Pyramid of Giza, Egypt`
    },
    {
      image: 'horseshoefalls.jpg',
      text: `Horseshoe Falls, Niagara Falls, Ontario`
    },
    {
      image: 'badlands.jpg',
      text: `Badlands National Park, South Dakota`
    },
    {
      image: 'liriver.jpg',
      text: `Li Jiang, China`
    },
    {
      image: 'chocolatethills.jpg',
      text: `Chocolate Hills in Bohol, Philippines`
    },
    {
      image: 'lotus.jpg',
      text: `Lotus Temple, New Delhi`
    },
    {
      image: 'spaceneedle.jpg',
      text: `Space Needle, Seattle`
    },
    {
      image: 'haydar.jpg',
      text: `Haydar Aliyev Centre, Azerbaijan`
    },
    {
      image: 'louvre.jpg',
      text: `Louvre Museum, Paris, France`
    },
    {
      image: 'stonehenge.jpg',
      text: `Stonehenge, England`
    },
    {
      image: 'tajmahal.jpg',
      text: `Taj Mahal, India`
    },
    {
      image: 'halong.jpg',
      text: `Halong Bay, Vietnam`
    },
    {
      image: 'easter.jpg',
      text: `Moai Statues, Easter Island`
    },
    {
      image: 'uluru.jpg',
      text: `Uluru, Northern Territory, Australia`
    },
    {
      image: 'romanforum.jpg',
      text: `Roman Forum, Rome, Italy`
    },
    {
      image: 'heceta.jpg',
      text: `Heceta Head Lighthouse, Oregon`
    },
    {
      image: 'kilamajaro.jpg',
      text: `Mount Kilimanjaro, Tanzania`
    },
    {
      image: 'varanasi.jpg',
      text: `Varanasi, India`
    },
    {
      image: 'faeroe.jpg',
      text: `Faroe Islands`
    },
    {
      image: 'stupa.jpg',
      text: `Boudhanath stupa, Kathmandu, Nepal`
    },
    {
      image: 'fitzroy.jpg',
      text: `Monte Fitz Roy, Patagonia`
    },
    {
      image: 'bryce.jpg',
      text: `Bryce Canyon National Park, Utah`
    },
    {
      image: 'cambodia.jpg',
      text: `The Bayon, Cambodia`
    },
    {
      image: 'goldengate.jpg',
      text: `Golden Gate Bridge, San Francisco`
    },
    {
      image: 'bigben.jpg',
      text: `Big Ben, London`
    },
    {
      image: 'newyork.jpg',
      text: `New York City`
    },
    {
      image: 'monolake.jpg',
      text: `Mono Lake, California`
    },
    {
      image: 'mahal.jpg',
      text: `Hawa Mahal, Jaipur, India`
    },
    {
      image: 'tajmahal.jpg',
      text: `Taj Mahal, India`
    },
    {
      image: 'acropolis.jpg',
      text: `The Acropolis, Athens, Greece`
    },
    {
      image: 'la.jpg',
      text: `Los Angeles, California`
    },
    {
      image: 'denali.jpg',
      text: `Mount Denali, Alaska`
    },
    {
      image: 'tahoe.jpg',
      text: `Lake Tahoe, Nevada`
    },
    {
      image: 'navajo.jpg',
      text: `Monument Valley Navajo Tribal Park, Arizona`
    },
    {
      image: 'morainta.jpg',
      text: `Moraine Lake, Alberta, Canada`
    },
    {
      image: 'tigers.jpg',
      text: `Tiger's Nest, Bhutan`
    },
    {
      image: 'basil.jpg',
      text: `St. Basil's Cathedral, Moscow, Russia`
    },
    {
      image: 'eiffel.jpg',
      text: `Eiffel Tower, Paris, France`
    }
  ]

  const masthead = _.sample(mastheads)

  export default {
    static: {
      masthead: Object.assign(masthead, {
        image: require(`@/components/GeographyMasthead/images/${masthead.image}`)
      })
    },
    data () {
      return {
        active: false,
        displayBg: false
      }
    },
    mounted () {
      this.displayBg = true
    }
  }

</script>

<style lang="scss" scoped>

  @import "~globals";

  .geography-masthead {
    display:flex; align-items:center; height:40vw; position:relative; overflow:hidden;
    .body {
      @include container;
      width:100%; position:relative; z-index:3;
    }
    h1 {
      @include font-size(xxlarge, $headline: true); text-align:center;
      mark {
        color:$color-primary;
      }
    }
  }

  .bg {
    position:absolute; top:0; bottom:0; left:0; right:0; background-size:cover; transition:transform 15s; transform:scale(1);
    &.v-enter {
      transform:scale(1.10);
    }
  }

  .location {
    position:absolute; bottom:8%; left:0; width:100%; text-align:center;
    @include media(small,medium) {
      display:none;
    }
    h2 {
      color:#fff; text-transform:uppercase; font-weight:500; font-size:2.4rem; line-height:1; cursor:pointer; text-shadow:2px 1px 2px rgba(0,0,0,0.7);
      svg {
        width:1em; height:auto; vertical-align:bottom; top:-1px; position:relative;
      }
    }
  }
  .reveal {
    @include font-size(xxlarge, $headline: true);
    margin:1rem 0 0; color:#fff; opacity:0; transition:opacity .3s; font-size:3.5rem !important;
    .location.active & {
      opacity:1;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/GeographyMasthead/index.vue